class SktLoyaltyTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
  }

  select(activeButton) {
    const activePanelId = activeButton.getAttribute('data-panel');

    this.buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activePanelId;
    });
  }
}

if (!window.customElements.get('skt-loyalty-tabs')) {
  window.customElements.define('skt-loyalty-tabs', SktLoyaltyTabs);
}
